import { compose, lifecycle } from 'recompose';
import translateRedux from './translateRedux';
import config from '../../../config';
import { getStoreLanguages } from '../Providers/StoreLanguagesApi';
import {
    getDefaultLanguage as getDefaultLanguageRaw,
    isValidLanguage as isValidLanguageRaw,
    isDefaultLanguage as isDefaultLanguageRaw
} from '../../Locale/Locale'

export const withTranslation = (page) => (Component) => {
    return compose(
        translateRedux,
        lifecycle({
            componentWillMount() {
                const lang = this.props.lang || (this.props.params && this.props.params.id);
                const url = `${config.api}/localization/${lang}?page=${page}`;
                fetch(url)
                .then(response => response.json())
                .then(translation => this.props.setTranslations(translation));
            },
        }))(Component)
}

//Keep alias wrappers for compatability
export const getDefaultLanguage = () => getDefaultLanguageRaw(getStoreLanguages(config.storeCode));

export const isValidLanguage = (lang) => isValidLanguageRaw(getStoreLanguages(config.storeCode), lang)

export const isDefaultLanguage = (lang) => isDefaultLanguageRaw(getStoreLanguages(config.storeCode), lang)

export const getLocalisedPath = (langCode, isDefault) => {
    let path = (window.location.pathname + window.location.search).split('/').slice(1);
    if (isValidLanguage(path[0])) {
        if (isDefault) {
            path.splice(0, 1);
            path = path.join('/');
        }
        else {
            path[0] = langCode;
            path = path.join('/');
        }
    } else {
        if (isDefault == 1) {
            path = path.join('/');
        } else {
            path = path[0] != "" ? langCode + '/' + path.join('/') : langCode;
        }
    }

    return path;
}

export const getPrintboxLocale = (lang) => {
    let countryCode = config.storeCode.substring(2);

    switch (countryCode) {
        case 'UK':
            countryCode = 'GB';
            break;
        default:
            countryCode = countryCode;
    }

    return `${lang}-${countryCode.toLowerCase()}`;
}



// WEBPACK FOOTER //
// ./src/Common/Translations/TranslationHelper.js